<template>
  <!-- 导出模式框 -->
  <Modal
    v-model="exportModal"
    width="360"
    @on-cancel="cancel"
    :mask-closable="false"
  >
    <p slot="header" style="color: #2d8cf0; text-align: center">
      <Icon type="ios-information-circle"></Icon>
      <span>导出确认</span>
    </p>
    <div style="text-align: center">
      <p>是否需要导出资源的标签?</p>
    </div>
    <div slot="footer">
      <Row :gutter="12">
        <Col span="12">
          <Button
            type="primary"
            size="large"
            :loading="loading"
            @click="yes"
            style="width: 100%"
            >是</Button
          >
        </Col>
        <Col span="12">
          <Button
            type="primary"
            size="large"
            :loading="modal_loading"
            @click="no"
            style="width: 100%"
            >否</Button
          >
        </Col>
      </Row>
    </div>
  </Modal>
</template>
<script>
export default {
  name: "Export",
  data() {
    return {
      exportModal: false,
      loading: false,
      modal_loading: false,
      type: 0, // 类型  0:云服务器  1:云数据库
    };
  },
  methods: {
    // 点击导出
    openExport(type) {
      this.exportModal = true;
      this.type = type;
    },
    // 是
    yes() {
      switch (this.type) {
        case 0:
          // 云服务器
          this.$parent.export(true);
          break;
        case 1:
          // 云数据库
          this.$parent.export(true);
          break;
        default:
          break;
      }
    },
    // 否
    no() {
      switch (this.type) {
        case 0:
          // 云服务器
          this.$parent.export(false);
          break;
        case 1:
          // 云数据库
          this.$parent.export(false);
          break;
        default:
          break;
      }
    },
    // 取消
    cancel() {
      this.loading = false;
      this.modal_loading = false;
      this.$Message.destroy();
    },
  },
};
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/configuration/resource_configuration_management/hwc/Export.vue